@if (initialized && dto) {
    @if (uiMode == 'side') {

        <bm-bank-transaction-family-full
                [objectIdentifier]="objectIdentifier"
                [dto]="dto"
                [uiMode]="uiMode"
                (onNavigationItems)="handleNavigationItems($event)"
        ></bm-bank-transaction-family-full>
    } @else {

        <bm-bank-transaction-family-side
                [objectIdentifier]="objectIdentifier"
                [dto]="dto"
                [uiMode]="uiMode"
                (onNavigationItems)="handleNavigationItems($event)"
        ></bm-bank-transaction-family-side>
    }
}
